"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var retryable_exports = {};
__export(retryable_exports, {
  retryAllErrors: () => retryAllErrors,
  retryNetworkErrors: () => retryNetworkErrors
});
module.exports = __toCommonJS(retryable_exports);
const retryAllErrors = /* @__PURE__ */ __name((_error) => {
  return true;
}, "retryAllErrors");
const NETWORK_ERROR_NAMES = /* @__PURE__ */ new Set([
  "NetworkError",
  "FetchError",
  "AbortError",
  "TimeoutError",
  "ConnectionError",
  "ConnectionRefusedError",
  "ETIMEDOUT",
  "ECONNREFUSED",
  "ECONNRESET",
  "ENOTFOUND",
  "EAI_AGAIN"
]);
const NETWORK_ERROR_PATTERNS = [
  /network/i,
  /connection/i,
  /timeout/i,
  /unreachable/i,
  /refused/i,
  /reset/i,
  /socket/i,
  /DNS/i,
  /ENOTFOUND/,
  /ECONNREFUSED/,
  /ECONNRESET/,
  /ETIMEDOUT/,
  /EAI_AGAIN/
];
const retryNetworkErrors = /* @__PURE__ */ __name((error) => {
  if (error == null) {
    return false;
  }
  if (error instanceof Error) {
    if (NETWORK_ERROR_NAMES.has(error.name)) {
      return true;
    }
    for (const pattern of NETWORK_ERROR_PATTERNS) {
      if (pattern.test(error.message)) {
        return true;
      }
    }
    if ("status" in error && typeof error.status === "number") {
      const status = error.status;
      return status >= 500 && status < 600 || // Server errors
      status === 429 || // Too Many Requests
      status === 408 || // Request Timeout
      status === 423 || // Locked
      status === 425 || // Too Early
      status === 449 || // Retry With
      status === 503 || // Service Unavailable
      status === 504;
    }
  }
  return false;
}, "retryNetworkErrors");
//# sourceMappingURL=retryable.js.map
